module.exports = __webpack_public_path__ + "assets/eab68eebf293549244e2f69af21b6e84.mp3";